module.exports = __webpack_public_path__ + "images/speed-one-active.f4df75baac1491d46d0a9e0dcab6649e.png";